import {OrderData} from '../hooks/type';
import {OrderItems} from '@buncha/batchDetails/types';
import {UserStub} from '@buncha/onBoarding/types';

/* eslint-disable no-shadow */
export enum B2BCheckoutTabs {
  'verification' = 'verification',
  'approval' = 'approval',
}

export interface B2BScreenParam {
  runId: number;
  storeId: number;
  storeIndex: string;
  orderLegacyIds?: number[];
}

export enum OrderInfoModes {
  'orderInfo' = 'orderInfo',
  'orderReturn' = 'orderReturn',
}

export interface B2BOrderDetailParam {
  runId: number;
  orderId: number;
  screenTitle: string;
  modes: OrderInfoModes;
  status: OrderVerifyStatus;
}

export interface B2BOrderInfoParam extends B2BOrderDetailParam {
  orderId: number;
}

export enum OrderVerifyStatus {
  pending = 'pending',
  validationInProgress = 'validationInProgress',
  validationFailed = 'validationFailed',
  validationDone = 'validationDone',
  updationInProgress = 'updationInProgress',
  updationFailed = 'updationFailed',
  updationDone = 'updationDone',
  barcodeScanned = 'barcodeScanned',
  scanSuccessful = 'scanSuccessful',
  scanFailed = 'scanFailed',
}
export interface Order {
  buyer: UserStub;
  id: number;
  externalId: string;
  items: OrderItems[];
}

export interface OrdersForUpdation {
  status: OrderVerifyStatus;
  order: Order;
}
export interface OrdersForValidation extends OrdersForUpdation {
  defectedItems?: OrderItems[];
}

export interface OrdersForValidationAndUpdationCheckout {
  ordersForValidation?: OrdersForValidation[];
  ordersForUpdation?: OrdersForUpdation[];
}

export interface GetOrdersForValidationAndUpdationCheckoutRes {
  getOrdersForValidationAndUpdation: {
    data: {
      V100: OrdersForValidationAndUpdationCheckout;
    };
  };
}

export interface OrderValidationUpdateRes {
  OrderValidation: {
    data: {
      V100: {orders: OrdersForUpdation[]};
    };
  };
}

export interface OrderActivity {
  id: number;
  orderId: number;
  referenceLink: string;
  verificationStatus: OrderVerifyStatus;
}

export interface UpdateB2BOrderRes {
  updateB2BOrder: {
    data: {
      V100: {
        status: boolean;
      };
    };
  };
}

export interface B2BCheckoutContextState {
  ordersForValidation?: OrdersForValidation[];
  ordersForUpdation?: OrdersForUpdation[];
}

export enum AsyncStatus {
  'declined' = 'declined',
  'accepted' = 'accepted',
  'failed' = 'failed',
  'pending' = 'pending',
}

export interface AsyncOrderStatusSuccess {
  orderId: number;
  status: AsyncStatus;
}
export interface AsyncOrderStatusError extends AsyncOrderStatusSuccess {
  error: string;
}

export interface AsyncOrderStatus {
  failed: AsyncOrderStatusError[];
  success: AsyncOrderStatusSuccess[];
}
export interface CheckAsyncOrderStatusRes {
  checkAsyncOrderStatus: {
    data: {
      V100: {
        asyncOrderStatus: AsyncOrderStatus;
      };
    };
  };
}

export interface UpdateDeliveryNotesResponse {
  data: OrderData;
}
